
<wiz-vgroup width="100%" height="100%" padding="0px" gap="0">
  <wiz-hgroup #hgDetailZone width="100%">
    <wiz-hgroup width="100%">
      <ng-container #containerFilter></ng-container>
    </wiz-hgroup>
    
    <wiz-hgroup width="50px" *ngIf="hasFilter" 
   horizontalAlign="end" verticalAlign="center">
      <wiz-icon #moreFilterIcon *ngIf="needMore" (click)="moreFilterPop()" 
          [wizTooltip]="'$.widget.more.filters.$'" tooltipPlacement="top"
          style="cursor: pointer; font-size: 20px"
          class="basicIcon black hoversave" >filters</wiz-icon>
      <wiz-icon *ngIf="hasActiveFilter" (click)="clearAllFilter()" 
        style="cursor: pointer; font-size: 20px"
        [wizTooltip]="'$.widget.clear.filters.$'" tooltipPlacement="top"
        class="basicIcon black hoversave" >cancel</wiz-icon>
    </wiz-hgroup>
  </wiz-hgroup>
  <wiz-ag-grid
    #agGrid
    width="100%"
    height="100%"
    [headerHeight]="headerHeight"
    [groupHeaderHeight]="groupHeaderHeight"
    [rowHeight]="rowHeight"
    [frameworkComponents]="gridFrameworkComponents"
    [wizDatasource]="fdvDS"
    [wizRowSelection]="showRowSelection"
    [columnDefs]="columns"
    [gridOptions]="gridOptions"
    [widget]="widget"
    [wizShowDelete]="showRowDeletion"
    class="ag-theme-alpine"
    (wizCellFile)="onCellFile($event)"
    (wizCellEdit)="onCellEdit($event)"
    (wizActionClicked)="onAction($event)"
    (wizImageClicked)="onImage($event)"
    (wizCellChecked)="onCellChecked($event)"
    (wizDeleteItem)="onItemDeleted($event)"
    (columnGroupOpened)="onColumnGroupEvent($event)"
  ></wiz-ag-grid>
  <wiz-hgroup verticalAlign="center" width="100%" horizontalAlign="end" gap="5" style="padding-right: 10px;">
    <wiz-label
      [wizLabel]="countLabel"
      class="smallFont"></wiz-label>
  </wiz-hgroup>
</wiz-vgroup>
